import { render, staticRenderFns } from "./HeadlineTitleList.vue?vue&type=template&id=1f36dda8&scoped=true&"
import script from "./HeadlineTitleList.vue?vue&type=script&lang=ts&"
export * from "./HeadlineTitleList.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineTitleList.vue?vue&type=style&index=0&id=1f36dda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36dda8",
  null
  
)

export default component.exports